// Formularios públicos (contacto, financiamiento, compra directa, consignación, buscamos por ti, modales de datos/éxito) y correos de leads — Español.
//
// Existe en es, pt y en (mismas claves; `npm run test:i18n-en-paridad` lo verifica).
// Estos textos estaban fijos en español en el código: cada valor de acá tiene que
// ser IDÉNTICO al literal que reemplaza.
//
// Las claves marcadas "solo BR" no reemplazan ningún literal: se muestran
// únicamente en sitios de Brasil (isBrasil(country)). El valor en español está
// para que es y pt tengan las mismas claves; un sitio chileno nunca lo ve.
export const formsUiEs = {
  // alert() de los formularios (FinancingForm, BuyDirectForm, ConsignmentsForm, WeSearchForm)
  errors: {
    noClient:
      '❌ Error: No se pudo identificar la automotora. Por favor, recarga la página.',
    generic:
      'Hubo un error al enviar tu solicitud. Por favor intenta nuevamente.',
    emailNotSent:
      'No se pudo enviar la notificación por email, pero tu solicitud fue registrada. Te contactaremos pronto.',
    duplicate:
      'Ya existe una solicitud con estos datos. Por favor, verifica la información.',
    invalidEmail:
      'Error con el email. Por favor, verifica que el email sea válido.',
    customer:
      'Error al crear el cliente. Por favor, verifica los datos personales.',
    lead: 'Error al crear la solicitud. Por favor, verifica los datos del vehículo.',
    technicalDetails: 'Detalles técnicos',
    requiredFields:
      '❌ Por favor, completa todos los campos obligatorios (Nombre, Apellido, Email, Teléfono).',
    brandAndModel: '❌ Por favor, selecciona una marca y modelo de vehículo.',
    // Va seguido del nombre del campo (texto del builder), concatenado.
    requiredField: '❌ Por favor completa el campo obligatorio: ',
  },
  // SuccessModal (defaults y mensajes por tipo de lead)
  success: {
    title: '¡Solicitud enviada con éxito!',
    message:
      'Tu solicitud ha sido recibida. Nos pondremos en contacto contigo lo antes posible.',
    button: 'Aceptar',
    consignment:
      'Tu solicitud de consignación ha sido recibida. Nos pondremos en contacto contigo lo antes posible para evaluar tu vehículo.',
    buyDirect:
      'Tu solicitud de venta ha sido recibida. Un asesor se comunicará contigo para ofrecerte una cotización por tu vehículo.',
    financing:
      'Tu solicitud de financiamiento ha sido recibida. Un ejecutivo se comunicará contigo para presentarte las opciones disponibles.',
    contact:
      'Tu mensaje ha sido recibido. Nos pondremos en contacto contigo lo antes posible.',
    search:
      'Tu solicitud de búsqueda ha sido recibida. Te contactaremos cuando encontremos vehículos que se ajusten a tus criterios.',
  },
  buyDirect: {
    successAppraisal:
      'Recibimos los datos de tu vehículo. En unos minutos te llega por correo un precio estimado de compra, y un asesor se comunica contigo para coordinar la tasación presencial.',
    // solo BR: placa brasileña (Mercosul ABC1D23 o vieja ABC1234)
    platePlaceholderBr: 'Ej: ABC1D23',
    plateInvalidBr: 'Revisa la placa: formato ABC1D23 o ABC1234.',
  },
  weSearch: {
    // solo BR: etiqueta del campo dinámico tipo "rut" cuando el builder no le puso nombre
    cpfLabelBr: 'CPF',
  },
  // ContactForm
  contact: {
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    reason: 'Motivo de Contacto',
    // Solo la ETIQUETA: el valor guardado (key del Select) sigue en español.
    reasons: {
      buy: 'Compra de Vehículo',
      sell: 'Venta de Vehículo',
      general: 'Consulta General',
      other: 'Otro',
    },
    message: 'Mensaje',
    submit: 'Enviar Mensaje',
    infoTitle: 'Información de Contacto',
    location: 'Ubicación',
    hours: 'Horario',
    directContact: 'Contacto Directo',
    emailsLabel: 'Emails',
    emailLabel: 'Email',
    phoneLabel: 'Teléfono',
  },
  // ContactClient (página /contact sin builder)
  contactPage: {
    title: 'Contacto',
    subtitle:
      'Estamos aqui para ayudarte. Envianos un mensaje y te responderemos lo antes posible.',
  },
  // CustomerDataModal
  customerModal: {
    title: '¡Guarda tus vehículos favoritos!',
    description:
      'Te notificaremos cuando encontremos vehículos similares a buen precio.',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    save: 'Guardar',
  },
};
